import { getProtoAfters, getProtoBefores } from "../decorators/aop/AOPDecorator.js";
import { ObjectUtils } from "@dooboostore/core";
import { ExceptionHandlerSituationType, targetExceptionHandler } from "../decorators/exception/ExceptionDecorator.js";
import { SituationTypeContainer, SituationTypeContainers } from "../decorators/inject/Inject.js";
class SimProxyHandler {
  constructor(simpleApplication, simstanceManager, simOption) {
    this.simpleApplication = simpleApplication;
    this.simstanceManager = simstanceManager;
    this.simOption = simOption;
  }
  // 잘받게 해놨네 ㅋㅋ  simstanceManager
  get(target, name) {
    if (name === "_SimpleBoot_application") {
      return this.simpleApplication;
    } else if (name === "_SimpleBoot_simstanceManager") {
      return this.simstanceManager;
    } else if (name === "_SimpleBoot_simOption") {
      return this.simOption;
    } else if (name === "_SimpleBoot_origin") {
      return target;
    } else {
      return target[name];
    }
  }
  set(obj, prop, value, receiver) {
    value = this.simstanceManager?.proxy(value);
    obj[prop] = value;
    return true;
  }
  apply(target, thisArg, argumentsList) {
    let r;
    try {
      this.aopBefore(thisArg, target);
      try {
        r = Reflect.apply(target, thisArg, argumentsList);
      } catch (e) {
        throw e;
      } finally {
        this.aopAfter(thisArg, target);
      }
    } catch (e) {
      console.error(e);
      const inHandlers = this.getExceptionHandler(e, thisArg, target);
      if (inHandlers.length > 0 && inHandlers[0]) {
        const inHandler = inHandlers[0];
        this.executeExceptionHandler(e, inHandler, argumentsList);
      } else {
        throw e;
      }
    }
    return r;
  }
  executeExceptionHandler(e, inHandler, argumentsList) {
    const otherStorage = /* @__PURE__ */ new Map();
    otherStorage.set(e.constructor, e);
    const situationErrorTypeContainer = new SituationTypeContainer({
      situationType: ExceptionHandlerSituationType.ERROR_OBJECT,
      data: e
    });
    const situationParameterTypeContainer = new SituationTypeContainer({
      situationType: ExceptionHandlerSituationType.PARAMETER,
      data: argumentsList
    });
    otherStorage.set(SituationTypeContainers, new SituationTypeContainers([situationErrorTypeContainer, situationParameterTypeContainer]));
    argumentsList?.forEach((it) => {
      otherStorage.set(it.constructor, it);
    });
    try {
      this.simstanceManager.executeBindParameterSim(
        {
          target: inHandler.thisArg,
          targetKey: inHandler.config.propertyKey
        },
        otherStorage
      );
    } catch (es) {
      e = es;
    }
    if (inHandler.config.config.throw) {
      const exceptionHandler = this.getExceptionHandler(e, inHandler.thisArg, inHandler.config.method);
      if ((exceptionHandler?.length ?? 0) > 0) {
        this.executeExceptionHandler(e, exceptionHandler[0], argumentsList);
      }
    }
  }
  getExceptionHandler(e, thisArg, target) {
    const globalConfigSets = this.simOption.advice.map((it) => this.simstanceManager?.getOrNewSim({ target: it })).filter((it) => it).map((it) => {
      return { thisArg: it, config: targetExceptionHandler(it, e, [target]) };
    }) ?? [];
    const thisConfigSet = { thisArg, config: targetExceptionHandler(thisArg, e, [target]) };
    const inHandlers = [thisConfigSet, ...globalConfigSets].filter((it) => it && it.config);
    return inHandlers;
  }
  aopBefore(obj, protoType) {
    const propertyName = ObjectUtils.prototypeName(obj, protoType);
    if (propertyName && obj) {
      getProtoBefores(obj, propertyName).forEach((it) => {
        it.call(obj, protoType, propertyName);
      });
      for (let i = 0; i < this.simOption.advice.length; i++) {
        const sim = this.simstanceManager?.getOrNewSim({ target: this.simOption.advice[i] });
        const protoBefores = getProtoBefores(sim, propertyName, Object.getPrototypeOf(obj));
        protoBefores.forEach((it) => {
          it.call(obj, protoType, propertyName);
        });
      }
    }
  }
  aopAfter(obj, protoType) {
    const propertyName = ObjectUtils.prototypeName(obj, protoType);
    if (propertyName) {
      getProtoAfters(obj, propertyName).forEach((it) => {
        it.call(obj, protoType, propertyName);
      });
      for (let i = 0; i < this.simOption.advice.length; i++) {
        const sim = this.simstanceManager?.getOrNewSim({ target: this.simOption.advice[i] });
        const protoBefores = getProtoAfters(sim, propertyName, Object.getPrototypeOf(obj));
        protoBefores.forEach((it) => {
          it.call(obj, protoType, propertyName);
        });
      }
    }
  }
  has(target, key) {
    if (key === "_SimpleBoot_isProxy") {
      return true;
    }
    return key in target;
  }
}
export {
  SimProxyHandler
};
//# sourceMappingURL=SimProxyHandler.js.map
